// Placeholder pages for routes that land in follow-on tickets off Z9-6064.
// Each shows enough scaffolding to confirm routing works without committing
// to a layout that will be re-done when the real content lands.

export function OrderCancelPage(): JSX.Element {
  return <Section title="Checkout cancelled" subtitle="You can return to the catalog and try again." />;
}

export function NotFoundPage(): JSX.Element {
  return <Section title="Not found" subtitle="That page does not exist." />;
}

function Section({ title, subtitle }: { title: string; subtitle: string }): JSX.Element {
  return (
    <section>
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <p className="mt-2 text-sm text-slate-600">{subtitle}</p>
    </section>
  );
}
